import React, { useEffect, useRef } from "react"
import { useLocation } from 'react-router-dom';

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { Link } from "react-router-dom"

import { route, routes } from "~/helpers/routeHelper"
import { perms, useAccess } from "~/context/access"
import { useAuth } from "~/context/auth"
import NewBadge from "../Shared/NewBadge";

const SidebarContent = () => {

  const location = useLocation();

  const ref = useRef();
  // hooks that check permissions
  const { iAmGranted, iAmNotGranted, iAmGrantedAny } = useAccess();
  const { user: authUser } = useAuth();

  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = location.pathname

    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")
      for (let i = 0; i < items.length; ++i) {
        let activeFor = items[i].getAttribute('data-active-for');
        let isActiveFor = false;
        if (activeFor) {
          activeFor = activeFor.split('~');
          isActiveFor = activeFor.some(function (pattern) {
            var re = new RegExp(pattern);
            return re.test(pathName);
          });
        }
        if (pathName === items[i].pathname || isActiveFor) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [location.href])

  useEffect(() => {
    ref.current.recalculate()
  }, [location.pathname])

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    if (item.classList.contains('active')) {
      return;
    }
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false
    }
    scrollElement(item);
    return false
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu" className="h-100">
          <ul className="metismenu list-unstyled d-flex flex-column h-100" id="side-menu">
            <li className="menu-title">Menu</li>

            <li>
              <Link to={route(routes.home)} data-active-for="^\/dashboard($|\/(.*)+)">
                <i className="bx bx-home-circle"></i>
                <span>Dashboard</span>
              </Link>
            </li>

            {iAmGranted(perms.view_users) && <li>
              <Link to={route(routes.list_users)} data-active-for="^\/user($|\/(.*)+)">
                <i className="bx bxs-user"></i>
                <span>Users</span>
              </Link>
            </li>}

            {iAmGranted(perms.view_own_dealer_group) && <li>
              <Link to={route(routes.view_dealer_group, authUser.dealerGroupId)} data-active-for="^\/group($|\/(.*)+)">
                <i className="mdi mdi-account-group"></i>
                <span>Group</span>
              </Link>
            </li>}

            {iAmGranted(perms.view_own_dealer_region) && <li>
              <Link to={route(routes.view_dealer_region, authUser.dealerRegionId)} data-active-for="^\/region($|\/(.*)+)">
                <i className="fas fa-globe-americas"></i>
                <span>Region</span>
              </Link>
            </li>}

            {iAmGranted(perms.view_dealer_regions) && iAmNotGranted(perms.view_own_dealer_region) && <li>
              <Link to={route(routes.list_dealer_regions)} data-active-for="^\/region($|\/(.*)+)">
                <i className="fas fa-globe-americas"></i>
                <span>Regions</span>
              </Link>
            </li>}

            {iAmGranted(perms.view_own_dealer_store) && <li>
              <Link to={route(routes.view_dealer_store, authUser.dealerStoreId)} data-active-for="^\/store($|\/(.*)+)">
                <i className="mdi mdi-store"></i>
                <span>Store</span>
              </Link>
            </li>}

            {iAmGranted(perms.view_dealer_stores) && iAmNotGranted(perms.view_own_dealer_store) && <li>
              <Link to={route(routes.list_dealer_stores)} data-active-for="^\/store($|\/(.*)+)">
                <i className="mdi mdi-store"></i>
                <span>Stores</span>
              </Link>
            </li>}

            {
              iAmGrantedAny([perms.view_group_usage_reports, perms.view_dealer_sales_reports]) &&
              <li>
                <Link to="/#" className="has-arrow">
                  <i className="mdi mdi-chart-line"></i>
                  <span>Reports</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  {iAmGranted(perms.view_group_usage_reports) && <li>
                    <Link to={route(routes.view_group_usage_report)} data-active-for="^\/group-usage-report($|\/(.*)+)">Group usage report</Link>
                  </li>}
                  {iAmGranted(perms.view_dealer_sales_reports) && <li>
                    <Link to={route(routes.view_dealer_sales_report)} data-active-for="^\/dealer-sales-report($|\/(.*)+)">Dealer sales report</Link>
                  </li>}
                </ul>
              </li>
            }

            {iAmGranted(perms.view_orders) && <li>
              <Link to={route(routes.list_orders)} data-active-for="^\/order($|\/(.*)+)">
                <i className="mdi mdi-shopping"></i>
                <span>Orders</span>
              </Link>
            </li>}

            {iAmGrantedAny([perms.view_statements, perms.view_payments]) && <li>
              <Link to="/#" className="has-arrow">
                <i className="mdi mdi-script-outline"></i>
                <span>Accounting</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                {iAmGranted(perms.view_statements) && <li>
                  <Link to={route(routes.list_dealers_statements)} data-active-for="^\/dealer-statement($|\/(.*)+)">Statements</Link>
                </li>}
                {iAmGranted(perms.view_invoices) && <li>
                  <Link to={route(routes.list_dealer_invoices)} data-active-for="^\/dealer-invoices($|\/(.*)+)">Orders</Link>
                </li>}
                {iAmGranted(perms.view_payments) && <li>
                  <Link to={route(routes.list_payments)} data-active-for="^\/payment($|\/(.*)+)">Payments</Link>
                </li>}
              </ul>
            </li>}

            <li>
              <Link to="/#" className="has-arrow ">
                <i className="mdi mdi-help-circle-outline"></i>
                <span>Help</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to={route(routes.list_help)} data-active-for="^\/help($|\/(.*)+)">
                    <i className="mdi mdi-help-circle-outline"></i>
                    <span>Help section</span>
                  </Link>
                </li>
                <li>
                  <Link to={route(routes.view_commercial_orders)} data-active-for="^\/commercial-orders($|\/(.*)+)">
                    <i className="mdi mdi-domain"></i>
                    <span>Commercial Orders</span>
                  </Link>
                </li>
                <li>
                  <Link to={route(routes.view_fedex)} data-active-for="^\/view-fedex($|\/(.*)+)">
                    <i className="mdi mdi-truck-fast-outline"></i>
                    <span>FedEx Labels</span>
                  </Link>
                </li>
                <li>
                  <Link to={route(routes.view_insurance_verification)} data-active-for="^\/insurance-verification($|\/(.*)+)">
                    <div className="d-flex align-items-center">
                      <i className="mdi mdi-shield-check"></i>
                      <span>Insurance Verification</span>
                    </div>
                  </Link>
                </li>
              </ul>
            </li>

            {iAmGranted(perms.view_pricing) && <li>
              <Link to="/#" className="has-arrow ">
                <i className="mdi mdi-wallet-membership"></i>
                <span>Manage subscription</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                {iAmGranted(perms.set_up_payment) && <li>
                  <Link to={route(routes.view_subscription)} data-active-for="^\/subscription($|\/(.*)+)">
                    <span>Subscription</span>
                  </Link>
                </li>}
                <li>
                  <Link to={route(routes.view_pricing)} data-active-for="^\/pricing($|\/(.*)+)">
                    <span>Pricing</span>
                  </Link>
                </li>
              </ul>
            </li>}

            {iAmGranted(perms.view_customer_calls) && <li>
              <Link to={route(routes.list_customer_calls)} data-active-for="^\/customer-call($|\/(.*)+)">
                <i className="mdi mdi-headphones"></i>
                <span>Calls</span>
              </Link>
            </li>}

            {iAmGranted(perms.view_document_templates) && <li>
              <Link to={route(routes.view_document_templates)} data-active-for="^\/view-document-templates($|\/(.*)+)">
                <i className="mdi mdi-file-refresh"></i>
                <span>Document Templates</span>
              </Link>
            </li>}

            <li>
              <Link to={route(routes.view_contact_us)} data-active-for="^\/contact-us($|\/(.*)+)">
                <i className="mdi mdi-email"></i>
                <span>Contact Us</span>
              </Link>
            </li>
            <li>
              <Link to={route(routes.route_one)} data-active-for="^\/route-one($|\/(.*)+)">
                <i className="mdi mdi-flag-checkered"></i>
                <span>RouteOne</span>
              </Link>
            </li>

            <li>
              <Link to={route(routes.view_price_increase)} data-active-for="^\/price-increase($|\/(.*)+)">
                <div className="d-flex align-items-center">
                  <i className="mdi mdi-cash-multiple"></i>
                  <span>Price Increase</span>
                  <div className="ms-2" style={{ width: 10 }}>
                    <NewBadge />
                  </div>
                </div>
              </Link>
            </li>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment >
  )
}

export default SidebarContent;
